'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _config = require('../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WysiwygStyles = function WysiwygStyles() {
  var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    hasTopMargin: false,
    hasBottomMargin: false,
    baseFontSize: _config.typography.baseFontSize,
    fontSize: '16px'
  };
  return '\n  font-size: ' + (0, _rem2.default)(conf.fontSize, conf.baseFontSize) + ';\n  margin-bottom: ' + function () {
    return conf.hasBottomMargin ? '30px' : '0';
  } + ';\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: ' + function () {
    return conf.hasTopMargin ? '30px' : '0';
  } + ';\n  width: 100%;\n\n  * {\n    font-family: proxima-nova, "Helvetica Nueue", sans-serif;\n  }\n\n  p {\n    line-height: 1.5em;\n    margin-bottom: 15px;\n  }\n\n  h1 {\n    font-size: 2.441em;\n    font-weight: 700;\n    margin-bottom: 15px;\n  }\n\n  h2 {\n    font-size: 1.953em;\n    font-weight: 500;\n    margin-bottom: 15px;\n  }\n\n  h3 {\n    font-size: 1.563em;\n    margin-bottom: 15px;\n  }\n\n  h4 {\n    font-size: 1.25em;\n    margin-bottom: 15px;\n  }\n\n  h5 {\n    font-size: 1em;\n    margin-bottom: 15px;\n  }\n\n  h6 {\n    font-size: 0.8em;\n    margin-bottom: 15px;\n  }\n\n  ul,\n  ol {\n    margin: 15px 0;\n\n    li:not(:first-of-type) {\n      margin-top: 12.5px;\n    }\n  }\n\n  ol {\n    list-style-type: none;\n    counter-reset: item;\n    padding-left: 25px;\n    position: relative;\n\n    > li {\n      counter-increment: item;\n\n      &::before {\n        content: counters(item, ".") ". ";\n        font-weight: 500;\n        left: 0;\n        position: absolute;\n      }\n    }\n  }\n\n  ul {\n    padding-left: 12px;\n    position: relative;\n\n    > li::before {\n      content: "\u2022";\n      color: ' + _config.colors.red + ';\n      position: absolute;\n      left: 0;\n    }\n  }\n\n  a {\n    color: ' + _config.colors.red + ';\n  }\n\n  strong,\n  b {\n    font-weight: bold;\n  }\n\n  em,\n  i {\n    font-style: italic;\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n';
};

exports.default = WysiwygStyles;